import React from 'react';
import { Form, Input, DatePicker, Button, Select, InputNumber } from 'antd';

const { RangePicker } = DatePicker;

const StepBasicInfo = ({ form, onNext }: { form: any; onNext: () => void }) => (
  <Form form={form}>
    <Form.Item
      label="活动名称"
      name="activityName"
      rules={[{ required: true }]}
    >
      <Input
        maxLength={20}
        showCount
        placeholder="请输入名称"
        style={{ width: 434 }}
      />
    </Form.Item>

    <Form.Item label="活动时间" name="timeRange" rules={[{ required: true }]}>
      <RangePicker showTime style={{ width: 434 }} />
    </Form.Item>

    <Form.Item
      label="活动类型"
      name="type"
      initialValue={0}
      rules={[{ required: true }]}
    >
      <Select style={{ width: 300 }}>
        <Select.Option value={0}>扭蛋券抽奖</Select.Option>
        <Select.Option value={1}>盲盒抽奖</Select.Option>
      </Select>
    </Form.Item>

    <Form.Item shouldUpdate>
      {({ getFieldValue }) => {
        const type = getFieldValue('type');
        return type !== 1 ? (
          <>
            <Form.Item
              label="最多中奖次数："
              name="maxWin"
              rules={[{ required: true, message: '请输入最多中奖次数' }]}
            >
              <InputNumber
                min={1}
                precision={0}
                addonAfter="次/人"
                style={{ width: 200 }}
              />
            </Form.Item>
            <Form.Item
              label="每天参与次数："
              name="dailyLimit"
              rules={[{ required: true, message: '请输入每天参与次数' }]}
            >
              <InputNumber
                min={1}
                precision={0}
                addonAfter="次/人"
                style={{ width: 200 }}
              />
            </Form.Item>
          </>
        ) : null;
      }}
    </Form.Item>

    <Form.Item
      label="活动规则"
      name="activityRule"
      rules={[{ required: true }]}
    >
      <Input.TextArea maxLength={800} showCount rows={4} />
    </Form.Item>

    <Form.Item
      label="活动说明"
      name="activityDesc"
      rules={[{ required: true }]}
    >
      <Input.TextArea maxLength={500} showCount rows={4} />
    </Form.Item>

    <Form.Item label="免责声明" name="disclaimer" rules={[{ required: true }]}>
      <Input.TextArea maxLength={500} showCount rows={4} />
    </Form.Item>

    <Form.Item label="备注" name="remark">
      <Input.TextArea maxLength={300} showCount rows={2} placeholder="请输入" />
    </Form.Item>

    <Button type="primary" onClick={onNext}>
      下一步
    </Button>
  </Form>
);

export default StepBasicInfo;
